import type { NewPolicyCommandData } from '@festina/life-general-types/life'
import { typeUtils } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'

import { useScenarioContext } from '../../context/scenarioContext'
import { useTranslatePolicy } from '../../hooks/useTranslatePolicy'
import { useHook } from '../../lenteHooks'
import type { CommandDataFormProps } from '../commandActions/CommandDataFormAndSimulation'
import { LifeForm } from '../forms/LifeForm'
import { initialFormEntriesFromVBase } from '../forms/yup/validation/yupValidationUtils'
import { LifeInput } from '../inputs/LifeInput'

export function CreatePolicyForm({
  commandData,
  shouldSkipFrame,
  ...props
}: CommandDataFormProps<NewPolicyCommandData>) {
  const translate = useTranslate()
  const translatePolicy = useTranslatePolicy()
  const { scenarioIdForRequestHeader } = useScenarioContext()
  const { tenantId, ownerId } = useHook('routing.general.useEntityParams')()

  const { data: newPolicyFrame } = useHook(
    'fetchers.life.useFetchNewPolicyFrame',
  )({
    tenantId,
    ownerId,
    scenarioIdForRequestHeader,
    commandData: {
      _type: 'NewPolicyCommandData',
      ...commandData,
    },
    enabled: shouldSkipFrame !== true,
  })

  const validateKey = typeUtils.createValidator<NewPolicyCommandData>()

  const defaultValues: NewPolicyCommandData = {
    _type: 'NewPolicyCommandData',
    ...initialFormEntriesFromVBase(newPolicyFrame),
  }

  return (
    <LifeForm initialValues={defaultValues} frame={newPolicyFrame} {...props}>
      <LifeInput
        fallbackInputType="date"
        name={validateKey('fromDate')}
        label={translate('createPolicyModalButton.fromDate')}
      />
      <LifeInput
        fallbackInputType="string"
        name={validateKey('policyTemplateId')}
        label={translate('createPolicyModalButton.policyTemplateId')}
        renderFn={(policyTemplateId: string) =>
          translatePolicy(policyTemplateId)
        }
      />
    </LifeForm>
  )
}
